var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{staticStyle:{"width":"310px"},attrs:{"value":_vm.content,"placeholder":_vm.placeholder,"type":_vm.type},on:{"on-change":function (e) { return _vm.$emit('change', e.target.value); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ded7fd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/input/index.vue
// module id = null
// module chunks = 